<template>
  <div class="favorites">
    <version-manage 
      deleteVersionApi="/resources/deleteResourcesById"
      getMaxVersionApi="/favResources/getMaxVersion"
      setLastVersionApi="/resources/updateResources"
      getVersionListApi="/favResources/getVersionList"
      addForceVersionApi="/favResources/addFileForceVersion"
      addNotForceVersionApi="/favResources/addFileNotForceVersion">
    </version-manage> 
  </div>
</template>

<script>
import VersionManage from '../../components/VersionManage.vue'
export default {
  name:"Favorites",
  components: { VersionManage },
  data:function(){
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.favorites{
  width:100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>